import styled from "@emotion/styled";

export const Page404 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 80px 0 40px;
  margin: 80px 0;
  position: relative;
  .imageWrapper {
    width: 220px;
    height: 190px;
    margin-bottom: 50px;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    color: #000000;
    margin-bottom: 10px;
  }
  .subtitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #808285;
    margin-bottom: 50px;
  }
  button {
    padding: 12px 20px;
    border-radius: 50px;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    text-align: center;
    &:hover {
      box-shadow: none;
    }
    a {
      color: #ffffff;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    span {
      margin-left: 10px;
      width: 30px;
    }
  }

  .timer {
    position: absolute;
    z-index: -1;
    color: aliceblue;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: clamp(80px, 100vw, 50rem);
      color: aliceblue;
    }
  }
`;
